import { useNavigate } from 'react-router-dom';
import logo from '../assets/2.png';

const About = () => {
    const navigate = useNavigate();

    return (
        <div className="home-layout">
            <img 
                src={logo} 
                alt="Gibo Logo" 
                className="about-logo" 
                onClick={() => navigate('/')}
            />

            <div className="about-box">
                <h3>About</h3>

                <p>
                    Gibo is a lightweight personal organiser designed to help you stay focused and productive. Gibo gives you a simple yet powerful
                     space to capture ideas, manage tasks, and organise your day—all in one place.
                </p>
               <p><span style={{ fontWeight: 800}}>Quick Notes: </span>Quickly capture ideas, 
               thoughts, and reminders as they come to you. This feature is 
               perfect for jotting things down without interrupting your workflow.</p>
                <p><span style={{ fontWeight: 800}}>Document Notes: </span>Create well-structured documents for planning, writing, and organising information. Keep all your important content neatly arranged in one place.
</p>
               <p><span style={{ fontWeight: 800}}>Kanban Boards: </span>Organise your 
               tasks visually using flexible Kanban boards. Easily track progress and 
               stay focused on what needs to be done next.
</p>
              <p><span style={{ fontWeight: 800}}>To-Do Lists: </span>Manage daily tasks 
              and long-term goals efficiently. Stay on top of your work with clear, 
              simple task tracking.
</p>

<p>Gibo keeps organisation simple, flexible, and personal—so you can focus on what matters most.
</p>

                <p style={{ fontSize: "0.8rem" }}>
                    Contact:{" "}
                    <span style={{ textDecoration: "underline", color: "burlywood" }}>
                        info@gibolab.com
                    </span>
                </p>
            </div>
        </div>
    );
};

export default About;